import React from 'react';
import './../Content.css';
import Retailers from './Retailers.js';
import CircularProgress from 'material-ui/CircularProgress';

export default class RetailerSearchResults extends React.Component {
  state = {
    loading: true,
    retailers: {},
  }

  componentDidMount = () => {
    var r = this.props.getRetailersFunc(this.props.zipcode)
    this.setState({
      retailers: r,
      loading: false,
    });
  }

  componentWillReceiveProps = (nextProps) => {
    this.setState({
      loading: true,
    });
    var r = this.props.getRetailersFunc(nextProps.zipcode)
    this.setState({
      loading: false,
      retailers: r,
    });
  }

  getHeading = (zipcode) => {
    if (zipcode) {
      return <h4>Stores near You - {zipcode}</h4>
    }
    return <h4>Select a store to start shopping</h4>
  }

  render() {
    return (
      <div key="retailers" className="app-content">
        {this.getHeading(this.props.zipcode)}
        {this.state.loading 
          ? <CircularProgress /> 
          : <Retailers retailers={this.state.retailers} destZipcode={this.props.zipcode}/>
        }
      </div>
    );
  }
}

RetailerSearchResults.propTypes = {
  zipcode: React.PropTypes.string,
  getRetailersFunc: React.PropTypes.func,
}

RetailerSearchResults.contextTypes = {
  router: React.PropTypes.object
};



// WEBPACK FOOTER //
// ./src/components/retailers/RetailerSearchResults.js